import { z } from 'zod';
import { getValidationIssueDescriptor } from '@powerful/types';
import { i18n } from './index';

/**
 * Mapa de erros do Zod traduzido.
 *
 * Sem isto, a validação de formulário emite as mensagens padrão do Zod — em inglês — dentro de
 * um app em francês ou espanhol. É o caso mais visível de i18n incompleto, porque aparece
 * exatamente quando o usuário já errou algo e está a ler com atenção.
 *
 * Registrar uma vez no arranque: `z.setErrorMap(zodErrorMap)`.
 */
export function zodIssueMessage(issue: z.ZodIssueOptionalMessage, defaultError = issue.message ?? ''): string {
  const t = (chave: string, valores?: Record<string, unknown>) =>
    i18n.t(`errors:validation.${chave}`, valores ?? {});
  const descriptor = getValidationIssueDescriptor(issue);

  return descriptor ? t(descriptor.key, descriptor.values) : defaultError;
}

/** O adaptador global preserva a mensagem padrão quando o erro não é do catálogo do produto. */
export const zodErrorMap: z.ZodErrorMap = (issue, ctx) => ({
  message: zodIssueMessage(issue, ctx.defaultError),
});

/** Deve ser chamado no bootstrap do app antes de qualquer formulário ser montado. */
export function configureZodI18n(): void {
  z.setErrorMap(zodErrorMap);
}
